module.exports = __webpack_public_path__ + "img/character_shizi.12d96600.png";